import styled, { css } from 'styled-components';
import type { TypographyProps } from '@makemydeal/dr-ui-bricks-types';
import { VARIANT_STYLES } from './constants';

// TODO: All the colors would be replaced with the ui-bricks theme
// Styled component for Typography with dynamic styles based on props
export const StyledTypography = styled.span<Required<Pick<TypographyProps, 'variant'>> & TypographyProps>`
    margin: 0;
    ${({ color, variant, noWrap, gutterBottom }) => css`
        color: ${color};
        ${VARIANT_STYLES[variant]};

        ${noWrap &&
        css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `}
        ${gutterBottom &&
        css`
            margin-bottom: 0.35em;
        `}
    `}
`;
